import {Tabs, TabsList, TabsTrigger} from '@/components/ui/tabs.tsx';
import type {UnitEconomicsAmountMode} from '../types';

type AmountModeToggleProps = {
	value: UnitEconomicsAmountMode;
	onChange: (value: UnitEconomicsAmountMode) => void;
};

export function AmountModeToggle({value, onChange}: AmountModeToggleProps) {
	return (
		<Tabs
			value={value}
			onValueChange={(next) => onChange(next as UnitEconomicsAmountMode)}
			className="w-full"
		>
			<TabsList className="h-9 w-full">
				<TabsTrigger value="perUnit" className="flex-1">
					На 1 ед
				</TabsTrigger>
				<TabsTrigger value="period" className="flex-1">
					На период
				</TabsTrigger>
			</TabsList>
		</Tabs>
	);
}
